import React from "react";

import Placeholder, { Rect } from "components/Placeholder";

type Props = {
  className?: string;
};

const ProductCardPlaceholder: React.FC<Props> = ({ className, ...others }) => (
  <div className={className} {...others}>
    <Placeholder width="112" height="112" className="mx-auto mb-md">
      <Rect width="100%" height="100%" />
    </Placeholder>
    <div>
      <Placeholder width="100%" height="60">
        <Rect width="40%" height="12" />
        <Rect y="22" width="85%" height="16" />
        <Rect y="48" width="115" height="12" />
      </Placeholder>
    </div>
  </div>
);

export default ProductCardPlaceholder;
